import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { setLoading } from '../../services/global/globalSlice'
import { fetchAddSubject, fetchEditSubject, fetchSubjects } from './SuperAdminApi'
import Form from 'react-bootstrap/Form'

export default function SubjectsManager(){
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [subjects, setSubjects] = useState([])
    const [search, setSearch] = useState('')
    const [editingId, setEditingId] = useState(null)
    const [formData, setFormData] = useState({ subject_name: '' })

    const filteredSubjects = useMemo(()=>{
        if(!search) return subjects
        const s = search.toLowerCase()
        return subjects.filter(sub => (sub?.subject_name || '').toLowerCase().includes(s))
    },[search, subjects])

    const loadSubjects = async () => {
        dispatch(setLoading(true))
        const response = await fetchSubjects()
        if(response.success){
            setSubjects(response.data || [])
        }
        dispatch(setLoading(false))
    }

    const handleEdit = (subject) => {
        setEditingId(subject?.subject_id)
        setFormData({ subject_name: subject?.subject_name || '' })
    }

    const resetForm = () => {
        setEditingId(null)
        setFormData({ subject_name: '' })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        dispatch(setLoading(true))
        let response
        if(editingId){
            response = await fetchEditSubject({ subject_id: editingId, subject_name: formData.subject_name })
        } else {
            response = await fetchAddSubject({ subject_name: formData.subject_name })
        }
        if(response.success){
            await loadSubjects()
            resetForm()
        }
        dispatch(setLoading(false))
    }

    useEffect(()=>{ loadSubjects() }, [])

    return (
        <section>
            <div className="d-flex justify-content-between align-items-end flex-wrap mb-3">
                <Form.Group className="mb-2 me-2" controlId="subject_search">
                    <Form.Label>{'Cerca'}</Form.Label>
                    <Form.Control type="text" placeholder={'Cerca...'} value={search} onChange={(e)=>setSearch(e.target.value)} />
                </Form.Group>
                <Form onSubmit={handleSubmit} className="d-flex align-items-end flex-wrap">
                    <Form.Group className="mb-2 me-2" controlId="subject_name">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control type="text" value={formData.subject_name} onChange={(e)=>setFormData({ ...formData, subject_name: e.target.value })} required />
                    </Form.Group>
                    <div className="mb-2 d-flex">
                        <button type="submit">{editingId ? (t?.buttons?.edit_save || 'Salva modifiche') : (t?.buttons?.save_create || 'Salva e crea')}</button>
                        {editingId ? <button type="button" className="ms-2" onClick={resetForm}>{t?.modals?.abort || 'Annulla'}</button> : null}
                    </div>
                </Form>
            </div>

            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nome</th>
                            
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredSubjects?.length ? filteredSubjects.map((s)=> (
                            <tr key={s.subject_id}>
                                <td>{s.subject_id}</td>
                                <td>{s.subject_name}</td>
                                <td>
                                    <button onClick={()=>handleEdit(s)}>{t?.actions?.open || 'Apri'}</button>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={4} className="text-center">Nessun elemento</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>
    )
}


